import { useState } from 'react';

const useBoolState = init => {
  const [state, setState] = useState(init);
  const setFalse = () => setState(false);
  const setTrue = () => setState(true);
  const toggle = () => setState(prevState => !prevState);
  const setExact = value => setState(value);
  return { state, setFalse, setTrue, toggle, setExact };
};

export default useBoolState;
